import React from 'react';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { WhiteBadgeStyled } from '@/app/components/search/components/EvolutionCard/Badges/BaseBadge/styled.ts';
import { MAX_THEME_BADGES } from '@/app/components/search/utils/buildDealCards/selectHotelThemeBadge.ts';
import type { BadgeContext } from '../types';

const HotelThemeBadge = ({ dealCard, remainingSlots }: BadgeContext) => {
  const { t } = useTranslation();
  const themes = dealCard.selectedHotelThemes?.slice(0, remainingSlots ?? MAX_THEME_BADGES);
  if (!themes?.length) return null;
  return (
    <>
      {themes.map((theme) => {
        const label = t(`vacation.oss.cards.badgets.${theme}`);
        return label ? <WhiteBadgeStyled key={theme}>{label}</WhiteBadgeStyled> : null;
      })}
    </>
  );
};

export default HotelThemeBadge;
